var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"aha-icon-button",class:[
    `aha-icon-button--${_vm.size}`,
    `aha-icon-button--${_vm.variant}`,
    {'active': _vm.isActive}
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }